import React from "react";
import Layout from "../../components/layout";
import Post from "../../components/blog/statuspage-alternatives/post";
import Cta from "../../components/blog/statuspage-alternatives/cta";
import Faq from "../../components/blog/statuspage-alternatives/faq";

const PostArticle = () => {
  return (
    <Layout>
      <Post />
      <Cta />
      <Faq />
    </Layout>
  );
};

export const Head = () => (
  <>
    <title>
      5 Atlassian Statuspage alternatives for incident communication | Blog |
      Sorry™
    </title>
    <meta
      name="description"
      content="Compare 5 Statuspage alternatives, from free open-source to enterprise tools with multi-page management. Find the right tool for your team and customers."
    />
    <meta property="og:title" content="5 Atlassian Statuspage alternatives for incident communication | Sorry™" />
    <meta property="og:description" content="Compare 5 Statuspage alternatives, from free open-source to enterprise tools with multi-page management. Find the right tool for your team and customers." />
    <meta property="og:type" content="article" />
    <meta property="og:url" content="https://www.sorryapp.com/blog/statuspage-alternatives" />
    <meta property="og:image" content="https://www.sorryapp.com/images/socials/og_card_statuspage_alternatives.png" />
    <meta property="og:image:alt" content="5 Atlassian Statuspage alternatives for incident communication social card" />
    <meta property="og:image:width" content="1200" />
    <meta property="og:image:height" content="630" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="5 Atlassian Statuspage alternatives for incident communication | Sorry™" />
    <meta name="twitter:description" content="Compare 5 Statuspage alternatives, from free open-source to enterprise tools with multi-page management. Find the right tool for your team and customers." />
    <meta name="twitter:url" content="https://www.sorryapp.com/blog/statuspage-alternatives" />
    <meta name="twitter:image" content="https://www.sorryapp.com/images/socials/og_card_statuspage_alternatives.png" />
    <meta name="twitter:image:alt" content="5 Atlassian Statuspage alternatives for incident communication social card" />
    <meta name="twitter:creator" content="@SorryApp" />

    <link
      rel="canonical"
      href="https://www.sorryapp.com/blog/statuspage-alternatives"
      data-gatsby-head="true"
    />
    <script type="application/ld+json">
      {JSON.stringify({
        "@context": "https://schema.org",
        "@type": "BlogPosting",
        headline:
          "5 Atlassian Statuspage alternatives for incident communication",
        description:
          "Compare 5 Statuspage alternatives, from free open-source to enterprise tools with multi-page management. Find the right tool for your team and customers.",
        image:
          "https://www.sorryapp.com/images/socials/og_card_statuspage_alternatives.png",
        url: "https://www.sorryapp.com/blog/statuspage-alternatives",
        datePublished: "2026-02-23",
        author: {
           "@type": "Person",
           name: "Jake Bartlett",
        },
        publisher: {
          "@type": "Organization",
          name: "Sorry™",
          logo: {
            "@type": "ImageObject",
            url: "https://www.sorryapp.com/sorry_logo_dark.svg",
          },
        },
      })}
    </script>
  </>
);

export default PostArticle;
